// extracted by mini-css-extract-plugin
module.exports = {"fuLogisticsRightList":"_1Fni3","li":"_2VTEb","liHead":"JA3Ty"};